(function () {
  function getProductRoot(node) {
    if (!(node instanceof Element)) return null;
    return node.closest("[data-bn-product]");
  }

  function setActiveGalleryMedia(root, mediaId) {
    if (!root || !mediaId) return;

    Array.prototype.slice.call(root.querySelectorAll("[data-bn-gallery-panel]")).forEach(function (panel) {
      var isActive = panel.getAttribute("data-media-id") === mediaId;
      panel.hidden = !isActive;
      panel.classList.toggle("is-active", isActive);
    });

    Array.prototype.slice.call(root.querySelectorAll("[data-bn-gallery-thumb]")).forEach(function (thumb) {
      var isActive = thumb.getAttribute("data-media-id") === mediaId;
      thumb.classList.toggle("is-active", isActive);
      thumb.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  function findModelPanel(root) {
    return Array.prototype.slice
      .call(root.querySelectorAll("[data-bn-gallery-panel]"))
      .filter(function (panel) {
        return panel.querySelector("product-model");
      })[0];
  }

  function findImagePanel(root) {
    return Array.prototype.slice
      .call(root.querySelectorAll("[data-bn-gallery-panel]"))
      .filter(function (panel) {
        return !panel.querySelector("product-model");
      })[0];
  }

  function replaceScopedFragment(root, selector, sourceDocument) {
    if (!root || !sourceDocument) return;

    var currentNode = root.querySelector(selector);
    var nextNode = sourceDocument.querySelector(selector);

    if (currentNode && nextNode) {
      currentNode.replaceWith(nextNode);
    }
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var thumb = target.closest("[data-bn-gallery-thumb]");
    if (!thumb) return;

    var root = getProductRoot(thumb);
    if (!root) return;

    event.preventDefault();
    setActiveGalleryMedia(root, thumb.getAttribute("data-media-id"));
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var posterButton = target.closest(".deferred-media__poster-button");
    if (!posterButton) return;

    var gallery = posterButton.closest("[data-bn-gallery]");
    if (!gallery) return;

    var productMedia = posterButton.closest(".product-media");
    if (!productMedia) return;

    productMedia.classList.add("is-model-active");
  });

  document.addEventListener("dblclick", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var panel = target.closest("[data-bn-gallery-panel]");
    if (!panel) return;

    var root = getProductRoot(panel);
    if (!root) return;

    if (panel.querySelector("product-model")) {
      var imagePanel = findImagePanel(root);
      if (!imagePanel) return;

      event.preventDefault();
      setActiveGalleryMedia(root, imagePanel.getAttribute("data-media-id"));
      return;
    }

    var modelPanel = findModelPanel(root);
    if (!modelPanel) return;

    event.preventDefault();

    setActiveGalleryMedia(root, modelPanel.getAttribute("data-media-id"));

    var posterButton = modelPanel.querySelector(".deferred-media__poster-button");
    if (posterButton) posterButton.click();
  });

  document.addEventListener("variant:update", function (event) {
    var target = event.target;
    var root = getProductRoot(target);
    var sourceDocument = event.detail && event.detail.data ? event.detail.data.html : null;

    if (!root || !sourceDocument) return;

    replaceScopedFragment(root, "[data-bn-gallery]", sourceDocument);
    replaceScopedFragment(root, "[data-bn-quantity-wrapper]", sourceDocument);
  });

  // "Leggi tutto": la descrizione è chiusa via CSS; il pulsante compare solo se il testo
  // supera davvero l'altezza chiusa. Ricalcolato quando il blocco viene sostituito (cambio variante).
  function initReadmore(scope) {
    Array.prototype.slice.call(scope.querySelectorAll("[data-bn-readmore]")).forEach(function (box) {
      if (box.hasAttribute("data-bn-readmore-ready")) return;
      box.setAttribute("data-bn-readmore-ready", "");

      var content = box.querySelector("[data-bn-readmore-content]");
      var toggle = box.querySelector("[data-bn-readmore-toggle]");
      if (!content || !toggle) return;

      var overflowing = content.scrollHeight > content.clientHeight + 8;
      toggle.hidden = !overflowing;
      box.classList.toggle("is-collapsible", overflowing);
    });
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target instanceof Element ? event.target.closest("[data-bn-readmore-toggle]") : null;
    if (!toggle) return;

    var box = toggle.closest("[data-bn-readmore]");
    var expanded = !box.classList.contains("is-expanded");
    box.classList.toggle("is-expanded", expanded);
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");

    var label = toggle.querySelector("[data-bn-readmore-label]");
    if (label) label.textContent = toggle.getAttribute(expanded ? "data-label-less" : "data-label-more");
  });

  function startReadmore() {
    initReadmore(document);
    var root = document.querySelector("[data-bn-product]");
    if (root && "MutationObserver" in window) {
      new MutationObserver(function () {
        initReadmore(root);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startReadmore);
  } else {
    startReadmore();
  }
})();
